import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { IIdentity } from '@/features/lp-account-users/models/lpaccount';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

const getLpAccountIdentities = async ({
  lpAccountID,
  makeRequest,
}: {
  lpAccountID: string;
  makeRequest: any;
}): Promise<IIdentity[] | null> => {
  const { data, error } = await makeRequest({
    path: `/admin/accounts/auth0/${lpAccountID}/identities`,
  });

  if (error) throw new Error(error);

  return data.identities;
};

type QueryFnType = typeof getLpAccountIdentities;

type UseGetLpAccountIdentities = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetLpAccountIdentities = ({
  config,
}: UseGetLpAccountIdentities = {}) => {
  const { id: lpAccountID } = useParams<{ id: string }>();
  const [, makeRequest] = useImperativeRequestWrapper('serviceLpAccount');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['identity', lpAccountID],
    queryFn: () =>
      getLpAccountIdentities({ lpAccountID: lpAccountID!, makeRequest }),
    enabled: !!lpAccountID,
  });
};
